var _path, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.691162C21.4425 0.691162 27.4999 6.9028 27.5 14.5955C27.5 22.2882 21.4425 28.4998 14 28.4998C6.55748 28.4998 0.5 22.2882 0.5 14.5955C0.500064 6.9028 6.55752 0.691162 14 0.691162Z",
    fill: "white",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.94727,
    y: 6.25623,
    width: 22.1053,
    height: 18.1951,
    fill: "url(#pattern0_5242_303)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5242_303",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5242_303",
    transform: "matrix(0.0082311 0 0 0.01 0.0884452 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5242_303",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADQklEQVR4nO2dvYsUMRiHf4qKjSAIohY2p4WKhSeonfXpebq8K6idjbUWYmNhZyceWKitIleJWGjhH+G32NiI4Aee2J23s6gEsrKEzPdk8jrzeyDVJsMkz77J5B02CxBCCCGEEC+bAewBsBPARn8VEppNAK4CeAPgz1RZAfAUwHzwOyD/OArgiyPCV57Y6CEBGQIYFZAxKa9sNJEG2QvgPIALAJISMiZlqcmb6TtDAKsVJLjlcOyOdAEpOT1llbuxO9OFyEgakmHKh9gd+p+RBiNjUsz11sbuWFciYwXA/ZpCzDq0JnbnuiDjF4A5+/k1TllxpynzrV5w6l2pKOV2i33pZGSsAjiRUr9spPwGcKjlPnVKxgjAyZx2ZaQ8aKkvnZUxKNi+iJTXTJ1UXzPGAM6gHFlrynsAO0per5cMUzZ9if2sLGmRsi/AvfduB55UlHLPc63TAe6/l+mQpKSUY3bz6O5fZgL2pXfpkDGAcwWuO+eRYdqebaFPvctNjXOkUEaERGGalON2WmJkRMjaulIoQ0EKfSIlbf/CNaPFl0vTT1+jhh6Te4MEeLmUFTWMjAwoQxHCyNCDUIYehDL0IJShB6EMPQhl6EEoQw9CGXoQytCDUIYehDL0IJShB6EMPQhl6EEoQw9CGXoQytCDUIYehDL0IJShB8pQBGUogjIUQRmKoAxFUIYiKEMRlKEIylAEZSiCMhRBGYqgDEVQhiIoQxGUoQjKUARlKIIyFEEZiqAMRez2HNIVqiQ8OySfGzw7RA/rAHzmQS56WHCmlJ8ArnOaisdDZ/Dv1DyUnkcc1WCL51zBIxn1KSMwFz1HZ2fByAjMc2eQL+fU5zQVkP2e/cH2nDZcMwJy0xngxwXa5C30PKOwIusBfHMGs+h/aqQ9EnMHXoOBM5jfAWzIaXMQwCKAZUZG8zxyBvVWSr1tdqF/x9xUOLZ6fmZmvvWzU9PZwK4peYcVm4QkDxmuyaWUwV22keKuLb7y1SYkd9W9GQK8qJECeWb/VcZEEWmA2Qoi3trHXTPVkYZZLCjhh00ymicrEpCs9x4j+/R1ilNSe3zyiHhpk4yckiJg/m3so40UM30diHEThBBCCCGEoDZ/AaqYlovcj6+dAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.baedb660716e52410a6fbd60b1b59eef.svg";
export { ForwardRef as ReactComponent };